<template>
    <div class="questionnaire">
        <iframe
            v-if="questionnaireUrl"
            :src="questionnaireUrl"
            frameborder="0"
            class="questionnaire-frame"
        ></iframe>
    </div>
</template>

<script setup>
const questionnaireUrl = '';
</script>

<style lang="scss" scoped>
.questionnaire {
    min-height: 720px;
    background: #ffffff;

    .questionnaire-frame {
        display: block;
        width: 100%;
        min-height: 720px;
    }
}
</style>
